import React from "react";

/* Reusable input */
function CustomInput({ label, required, ...props }) {
    return (
        <div className="flex flex-col gap-[5px]">
            <label className="font-semibold text-[13px] text-[#212326]">
                {label} {required ? <span className="text-[#ff5323]">*</span> : <span className="text-[#9298a0]">(optional)</span>}
            </label>
            <input
                {...props}
                className="w-full h-[44px] rounded-[10px] border border-[#e4e5e7] px-[14px] font-medium text-[14px] text-[#212326] placeholder:text-[#9298a0] focus:outline-none focus:border-[#ff5323] transition-colors"
            />
        </div>
    );
}

export default CustomInput;